"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true,
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactBootstrapIcons = require("react-bootstrap-icons");

require("../Styles/Footer.styles.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Footer = function Footer() {
  return /*#__PURE__*/ _react.default.createElement(
    "div",
    {
      className: "footerWrapper",
    },
    /*#__PURE__*/ _react.default.createElement(
      "div",
      {
        className: "footerTopSection container",
      },
      /*#__PURE__*/ _react.default.createElement(
        "div",
        null,
        /*#__PURE__*/ _react.default.createElement(
          _reactRouterDom.Link,
          {
            to: "/",
            onClick: function onClick() {
              window.scrollTo(0, 0);
            },
          },
          /*#__PURE__*/ _react.default.createElement("img", {
            src: "https://d241vrp4b4n7qa.cloudfront.net/Assets/logo_icon.svg",
            alt: "logo",
            className: "footerLogo",
          })
        )
      ),
      /*#__PURE__*/ _react.default.createElement(
        "div",
        {
          className: "footerDetails",
        },
        /*#__PURE__*/ _react.default.createElement(
          "div",
          {
            className: "footerDetailsSection",
          },
          /*#__PURE__*/ _react.default.createElement(
            "p",
            {
              className: "footerDetailsColHeader",
            },
            "Contact"
          ),
          /*#__PURE__*/ _react.default.createElement(
            "a",
            {
              className: "footerDetailsContent",
              href: "mailto:info@baxus.co",
              target: "_blank",
              rel: "noreferrer",
            },
            "info@baxus.co"
          )
        ),
        /*#__PURE__*/ _react.default.createElement(
          "div",
          {
            className: "footerDetailsSection",
          },
          /*#__PURE__*/ _react.default.createElement(
            "p",
            {
              className: "footerDetailsColHeader",
            },
            "Company"
          ),
          /*#__PURE__*/ _react.default.createElement(
            "a",
            {
              className: "footerDetailsContent",
              href: "/privacy",
            },
            "Privacy"
          ),
          /*#__PURE__*/ _react.default.createElement(
            "a",
            {
              className: "footerDetailsContent",
              href: "/termsconditions",
            },
            "Terms and conditions"
          )
        )
      )
    ),
    /*#__PURE__*/ _react.default.createElement(
      "div",
      {
        className: "footerBottomSection container",
      },
      /*#__PURE__*/ _react.default.createElement(
        "p",
        {
          className: "footerCopyright",
        },
        "Copyright \xA9 2022 Baxus. All Rights Reserved."
      ),
      /*#__PURE__*/ _react.default.createElement(
        "div",
        {
          className: "footerSocialSection",
        },
        /*#__PURE__*/ _react.default.createElement(
          "a",
          {
            className: "baxusSocialButton",
            href: "https://twitter.com/BAXUS_NFT",
            target: "_blank",
            rel: "noreferrer",
          },
          /*#__PURE__*/ _react.default.createElement(
            _reactBootstrapIcons.Twitter,
            null
          )
        ),
        /*#__PURE__*/ _react.default.createElement(
          "a",
          {
            className: "baxusSocialButton",
            href: "https://www.linkedin.com/company/baxus-nft/",
            target: "_blank",
            rel: "noreferrer",
          },
          /*#__PURE__*/ _react.default.createElement(
            _reactBootstrapIcons.Linkedin,
            null
          )
        )
      )
    )
  );
};

var _default = Footer;
/*
  <div className="footerDetailsSection">
            <p className="footerDetailsColHeader">Site Map</p>
            <a className="footerDetailsContent" href="/">Home</a>
            <a className="footerDetailsContent" href="/Assets">Assets</a>
            <a className="footerDetailsContent" href="#">Redeem</a>
          </div>
  <a className="footerDetailsContent" href="tel:18001234567">1 800 123 4567</a>
  <div className="footerDetailsSection">
            <p className="footerDetailsColHeader">Address</p>
            <p className="footerDetailsContent">12345 Somewhere Street</p>
            <p className="footerDetailsContent">Nashville, Tx 76051</p>
          </div>
*/

exports.default = _default;
